export const appstoreConstants = {
    APPSTORE_CHANGE_VALUE: "APPSTORE_CHANGE_VALUE",

    // Available apps
    GET_AVAILABLE_APPS_STARTED: "GET_AVAILABLE_APPS_STARTED",
    GET_AVAILABLE_APPS_SUCCESS: "GET_AVAILABLE_APPS_SUCCESS",
    GET_AVAILABLE_APPS_FAILURE: "GET_AVAILABLE_APPS_FAILURE",

    SEARCH_AVAILABLE_APPS_STARTED: "SEARCH_AVAILABLE_APPS_STARTED",
    SEARCH_AVAILABLE_APPS_SUCCESS: "SEARCH_AVAILABLE_APPS_SUCCESS", 
    SEARCH_AVAILABLE_APPS_FAILURE: "SEARCH_AVAILABLE_APPS_FAILURE",

    // Installed apps
    GET_INSTALLED_APPS_STARTED: "GET_INSTALLED_APPS_STARTED",
    GET_INSTALLED_APPS_SUCCESS: "GET_INSTALLED_APPS_SUCCESS",
    GET_INSTALLED_APPS_FAILURE: "GET_INSTALLED_APPS_FAILURE",

    // Install app
    INSTALL_APP_STARTED: "INSTALL_APP_STARTED",
    INSTALL_APP_SUCCESS: "INSTALL_APP_SUCCESS",
    INSTALL_APP_FAILURE: "INSTALL_APP_FAILURE",

    // Uninstall app
    UNINSTALL_APP_STARTED: "UNINSTALL_APP_STARTED",
    UNINSTALL_APP_SUCCESS: "UNINSTALL_APP_SUCCESS",
    UNINSTALL_APP_FAILURE: "UNINSTALL_APP_FAILURE",

    // App status
    GET_APP_STATUS_STARTED: "GET_APP_STATUS_STARTED",
    GET_APP_STATUS_SUCCESS: "GET_APP_STATUS_SUCCESS",
    GET_APP_STATUS_FAILURE: "GET_APP_STATUS_FAILURE",

    // Featured apps
    GET_FEATURED_APPS_STARTED: "GET_FEATURED_APPS_STARTED",
    GET_FEATURED_APPS_SUCCESS: "GET_FEATURED_APPS_SUCCESS",
    GET_FEATURED_APPS_FAILURE: "GET_FEATURED_APPS_FAILURE",

    // Categories
    GET_CATEGORIES_STARTED: "GET_CATEGORIES_STARTED",
    GET_CATEGORIES_SUCCESS: "GET_CATEGORIES_SUCCESS",
    GET_CATEGORIES_FAILURE: "GET_CATEGORIES_FAILURE",

    // Apps by category
    GET_CATEGORY_APPS_STARTED: "GET_CATEGORY_APPS_STARTED",
    GET_CATEGORY_APPS_SUCCESS: "GET_CATEGORY_APPS_SUCCESS",
    GET_CATEGORY_APPS_FAILURE: "GET_CATEGORY_APPS_FAILURE"
};